import { Label, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutIntercompanyBrokerageInfo extends Layout {
    labelBrCarContact: Label;
    labelBrCarContactValue: Label;
    labelBrCarEmail: Label;
    labelBrCarEmailValue: Label;
    labelBrCarPhone: Label;
    labelBrCarPhoneValue: Label;
    labelBrDriver1: Label;
    labelBrDriver1Email: Label;
    labelBrDriver1EmailValue: Label;
    labelBrDriver1Phone: Label;
    labelBrDriver1PhoneValue: Label;
    labelBrDriver1Value: Label;
    labelBrDriver2: Label;
    labelBrDriver2Email: Label;
    labelBrDriver2EmailValue: Label;
    labelBrDriver2Phone: Label;
    labelBrDriver2PhoneValue: Label;
    labelBrDriver2Value: Label;
    labelBrTractor: Label;
    labelBrTractorValue: Label;
    labelBrTrailer: Label;
    labelBrTrailerType: Label;
    labelBrTrailerTypeValue: Label;
    labelBrTrailerValue: Label;
    labelCarrierName: Label;
    labelCarrierNameValue: Label;
    panelICBrokerage: Panel;
    panelICBrokerageContact: Panel;
    panelICBrokerageDriver: Panel;
    panelICBrokerageEquip: Panel;
}
